// Staging-fakes workstream ask: make the engine choice visible so nobody mistakes a mock
// verdict for a real one — and so an instant COI clear is not read as "the portal is broken"
// (SoftR's real Prophy check took ~15 minutes; the mock resolves immediately).
import { Badge } from "../../components/ui.js";
import { useFeatures } from "../../hooks/useFeatures.js";

export function MockEngineBadge(): JSX.Element | null {
  const { features } = useFeatures();
  if (!features.coi.enabled || features.coi.engine !== "mock") return null;
  return (
    <span title="COI_ENGINE=mock — no real Prophy call; verdicts are simulated and resolve instantly">
      <Badge tone="violet">COI: demo engine — checks clear instantly</Badge>
    </span>
  );
}
